import { Card } from '@/components/ui/card';
import { Warehouse, Truck, Users } from 'lucide-react';
import { LocationTypeSection } from './location-type-section';
import type { MapLocation } from '@/entities/dashboard';

interface LocationStatisticsProps {
  locationsByType: {
    warehouses: MapLocation[];
    transports: MapLocation[];
    customers: MapLocation[];
  };
  formatNumber: (num: number) => string;
}

export function LocationStatistics({ locationsByType, formatNumber }: LocationStatisticsProps) {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Location Statistics</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <LocationTypeSection
          title="Warehouses"
          icon={Warehouse}
          iconColor="text-blue-600"
          locations={locationsByType.warehouses}
          formatNumber={formatNumber}
          dataField="weight"
          dataSuffix="mt"
        />

        <LocationTypeSection
          title="Transport Hubs"
          icon={Truck}
          iconColor="text-green-600"
          locations={locationsByType.transports}
          formatNumber={formatNumber}
          dataField="consignments"
          dataSuffix="shipments"
        />

        <LocationTypeSection
          title="Customer Sites"
          icon={Users}
          iconColor="text-orange-600"
          locations={locationsByType.customers}
          formatNumber={formatNumber}
          dataField="volume"
          dataSuffix="m³"
        />
      </div>
    </Card>
  );
}
